// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Question$ReactHooksTemplate = require("./Question.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");

function id(t) {
  if (t.TAG === "Question") {
    return Question$ReactHooksTemplate.id(t._0);
  } else {
    return DataField$ReactHooksTemplate.id(t._0);
  }
}

function name(t) {
  if (t.TAG === "Question") {
    return "Question";
  } else {
    return "DataField";
  }
}

exports.id = id;
exports.name = name;
/* Question-ReactHooksTemplate Not a pure module */
